var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('data-table',{attrs:{"headers":_vm.headers,"fields":_vm.fields,"items":_vm.items,"viewAction":'view-account',"addAction":'show-chart-of-accounts',"title":"GL Accounts"}}),_vm._v(" "),_c('chart-of-accounts',{attrs:{"show-button":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c81a58","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/accounting/general-ledger/accounts/AccountList.vue
// module id = rGt/
// module chunks = 0 1